import * as React from 'react';

import gql from 'graphql-tag';
import { Query } from 'react-apollo';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Switch from '@material-ui/core/Switch';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import RestoreIcon from '@material-ui/icons/Restore';
import LinearProgress from '@material-ui/core/LinearProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';

import Rest from "../../../../services/Rest";

import "./TableUsers.scss";
const styles = {
    textField: {
      marginLeft: 5,
      marginRight: 5,
    },
};

// tslint:disable-next-line:no-empty-interface
export interface ITableUsersPros {
    receiveUserToEdit(user: any): void,
    resetPassword(user: any, newPassword: string): void
}

export interface ITableUsers {
  count: number,
  limit: number,
  newPassword: string,
  offset: number,
  openDialogMoreInfo: boolean,
  openDialogResetPassword: boolean,
  page: number,
  rowToView: any,
  rows?: any,
  user: {
    id:number,
    email: string,
    password: string,
    fullname: string,
    username: string,
    isinternal: boolean,
    ssoid:string,
    deletedat: string
  }
}

const QUERY_SEARCH_USERS = gql`
    query getUserRegister($customFilter:  UserFilter) {
        getUserRegister(userFilter: $customFilter) {
            deletedat,email,fullname,ssoid,id, isinternal,password,username
        }
    }
`;

const QUERY_DELETE_USERS = ` query inativateUserRegister($customFilter:  UserFilter) { inativateUserRegister(userFilter: $customFilter) } `;

export class TableUsers
  extends React.Component<ITableUsersPros, ITableUsers> {

    constructor(props: ITableUsersPros) {
        super(props);
    
        this.state = {
          count: 10,
          limit: 10,
          newPassword: '',
          offset: 0,
          openDialogMoreInfo: false,
          openDialogResetPassword: false,
          page: 0,
          rowToView: {},
          rows: [],
          user: {
            deletedat:'',
            email: '',
            fullname: '',
            id: 0,
            isinternal: false,
            password: '',
            ssoid: '',
            username: ''
          }
        }

        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleResetPassword = this.handleResetPassword.bind(this);
    }

    public changeState = (user:any) => {
        this.setState( {user} );
    }

    public render() {

        const filter = {
            "customFilter" : {
                email: this.state.user.email,
                fullname: this.state.user.fullname,
                id: this.state.user.id,
                isinternal: this.state.user.isinternal,
                password: this.state.user.password,
                ssoid: this.state.user.ssoid,
                username: this.state.user.username
            }
        };
        return (
            <Query query={QUERY_SEARCH_USERS} variables={filter} partialRefetch={true} fetchPolicy="no-cache" >
                {({ loading, error, data}) => {
                    return (
                        <div>

                            <Dialog
                                open={this.state.openDialogMoreInfo}
                                onClose={this.handleCloseDialogMoreInfo}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">
                                    {this.state.rowToView.fullname}
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        <Grid container={true} spacing={24}>
                                            <Grid item={true} xs={6}>
                                                <Typography variant="body1">Usuário: {this.state.rowToView.username}</Typography>
                                            </Grid>

                                            <Grid item={true} xs={6}>
                                                <Typography variant="body1">E-mail: {this.state.rowToView.email}</Typography>
                                            </Grid>

                                            <Grid item={true} xs={6}>
                                                <Typography variant="body1">SSO Id: {this.state.rowToView.ssoid}</Typography>
                                            </Grid>

                                            <Grid item={true} xs={6}>
                                                <Typography variant="body1">Interno: {this.getInternalStr(this.state.rowToView.isinternal)}</Typography>
                                            </Grid>

                                            <Grid item={true} xs={6}>
                                                <Typography variant="body1">Ativo: {this.getIsActiveStr(this.state.rowToView.deletedat)}</Typography>
                                            </Grid>

                                        </Grid>
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={this.handleCloseDialogMoreInfo} color="primary">
                                        Fechar
                                    </Button>
                                </DialogActions>
                            </Dialog>

                            <Dialog
                                open={this.state.openDialogResetPassword}
                                onClose={this.handleCloseDialogResetPassword}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">
                                    Resetar senha de {this.state.rowToView.fullname}
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        <TextField
                                            id="standard-password-input"
                                            label="Nova senha:"
                                            value={this.state.newPassword}
                                            style={this.textFieldStyle()}
                                            onChange={this.handleChangeField()}
                                            type="text"
                                            autoComplete="new-password"
                                            margin="normal"
                                            className="formTextFieldReset"
                                            required={true}
                                        />
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={this.handleCloseDialogResetPassword} color="primary">
                                        Cancelar
                                    </Button>
                                    <Button onClick={this.handleResetPassword} color="primary">
                                        Reset
                                    </Button>
                                </DialogActions>
                            </Dialog>

                            {loading ? <LinearProgress /> : 
                                <div>    
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Ordem</TableCell>
                                                <TableCell>Usuário</TableCell>
                                                <TableCell>Email</TableCell>
                                                <TableCell>Ativo</TableCell>
                                                <TableCell>Ação</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {this.getTableBody(error, data)}
                                    </Table>
                                    <TablePagination
                                        component="div"
                                        page={this.state.page}
                                        count={data && data.getUserRegister ? data.getUserRegister.length : this.state.count}
                                        rowsPerPage={this.state.limit}
                                        rowsPerPageOptions={[]}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={undefined}
                                    />
                                </div>
                            }
                        </div>
                    );
                }}
            </Query>
        );
    }

    public getTableBody (error: any, data: any) {

        if(!error && data && data.getUserRegister) {
            return (
                <TableBody>
                    {
                        this.paginacaoVirtual(data.getUserRegister).map((row: any, key: number) => {
                            return (
                                <TableRow key={key}>
                                    <TableCell component="th" scope="row" className="padding-left">{ 1 + key + (this.state.page * this.state.limit) }</TableCell>
                                    <TableCell>{row.username}</TableCell>
                                    <TableCell>{row.email}</TableCell>
                                    <TableCell>
                                        <Switch
                                            checked={row.deletedat==null || row.deletedat===undefined || row.deletedat === ""}
                                            onChange={this.inativateItem.bind(this, row)}
                                            value="user.deletedat"
                                            color="primary"
                                        />
                                    </TableCell>
                                    <TableCell className="actionColumn">
                                        <Tooltip title="Editar">
                                            <IconButton className="editAction"  onClick={this.editItem.bind(this, row)} aria-label="Editar">
                                                <EditIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Visualizar">
                                            <IconButton className="viewAction" color="primary" onClick={this.handleOpenDialogMoreInfo.bind(this, row)} aria-label="Visualizar">
                                                <VisibilityIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Resetar Senha">
                                            <IconButton className="resetPasswordAction" color="primary" onClick={this.handleOpenDialogResetPassword.bind(this, row)} aria-label="Resetar Senha">
                                                <RestoreIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            );
                        })
                    }
                </TableBody>
            );
        } else {
            return null;
        }
    }

    public inativateItem (row : any) {

        const user = {
            "customFilter" : {
                deletedat: row.deletedat,
                id: row.id
            }
        };

        const body = {
            "operationName":"",
            "query":QUERY_DELETE_USERS,
            "variables": user
        };
        
        Rest.GraphqlPOST(body)
            .then( data  => {
                if(row.deletedat != null && row.deletedat !== undefined && row.deletedat !== "" ) {
                    row.deletedat = null;
                } else {
                    row.deletedat = "ok";
                }
                this.forceUpdate();
                
            });
    }

    public editItem (row : any) {
        this.props.receiveUserToEdit(row);
    };

    public handleResetPassword () {
        this.props.resetPassword(this.state.rowToView, this.state.newPassword);
        this.handleCloseDialogResetPassword();
    }

    private getInternalStr (isinternal : boolean) {
        if(isinternal != null && isinternal !== undefined && isinternal !== false) {
            return 'Sim';
        } else {
            return 'Não';
        }
    }

    private getIsActiveStr (deletedat:string) {
        if(deletedat) {
            return 'Não';
        } else {
            return 'Sim';
        }
    }

    /**
     * View Data
     * 
     * Methods that manager the dialog that show details from row selected
     */
    private handleOpenDialogMoreInfo = (row : any) => {
        this.setState({ openDialogMoreInfo: true, rowToView: row });
    };

    private handleCloseDialogMoreInfo = () => {
        this.setState({ openDialogMoreInfo: false, rowToView: {} });
    };

    private handleOpenDialogResetPassword = (row: any) => {
        this.setState( { openDialogResetPassword: true, rowToView: row, newPassword: "" } )
    };

    private handleCloseDialogResetPassword = () => {
        this.setState({ openDialogResetPassword: false, rowToView: {}, newPassword: "" });
    };


    /**
     * Pagination
     * 
     * Methods add pagination to the result table
     * 
     */
    private paginacaoVirtual = (bookstoreAnalysisData: any[]) => {
        const start = this.state.offset;
        const end = start + 10;
        return bookstoreAnalysisData.slice(start, end)
    }

    private handleChangePage(ev: any, pageParam: number) {

        if (pageParam <= this.state.page) {
            this.setState({
                offset: pageParam * 10 <= 0 ? 0 : pageParam * 10,
                page: pageParam,
            });
        } else {
            this.setState({
                offset: pageParam * 10,
                page: pageParam,
            });
        }
    }

    private textFieldStyle = () => {
        return Object.assign({}, styles.textField)
    }

    private handleChangeField = () => (event: React.FormEvent<HTMLInputElement>) => {
        this.setState({ newPassword: event.currentTarget.value });
    };
}


// WEBPACK FOOTER //
// ./src/component/administration/registers/users/TableUsers.tsx